import styled from "styled-components";
import { Empty } from "antd-mobile";
import { useIntl } from "react-intl";
export default function CellBox({ list }) {
  const intl = useIntl()
  return (
    <>
      {list.length && list.length > 0 ? (
        <CellBoxsWrapper>
          {list.map((e, i) => (
            <CellBoxWrapper
              key={i}
              onClick={() => {
                e.onClick && e.onClick();
              }}
            >
              <Flex>
                {e.icon ? (
                  <img
                    style={{ width: "3.0rem", marginRight: "1.0rem",...(e.iconStyle || {}) }}
                    src={e.icon}
                    alt={e.label}
                  />
                ) : null}
                <span style={{whiteSpace: 'nowrap'}}>{e.label}</span>
              </Flex>
              <Text>{e.text}</Text>
            </CellBoxWrapper>
          ))}
        </CellBoxsWrapper>
      ) : (
        <Empty description={intl.formatMessage({id:'common.no_data',defaultMessage:'暫無數據'})} />
      )}
    </>
  );
}

const CellBoxsWrapper = styled.div`
  border: 2px solid #000;
  border-radius: 2.2rem;
  box-shadow: 2px .25rem .0rem #000;
`;

const CellBoxWrapper = styled.div`
  padding: 1.2rem 2.0rem;
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 1.6rem;
  line-height: 1.6rem;
  color: #000;
  &:last-child {
    border: none;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const Text = styled.span`
  display: inline-block;
  width: 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: right;
`;
